import {errorHandler} from "@/services/errorHandler";
import axios from "axios";

export default {
    name: "kazang",
    state: {
    },
    getters: {
    },
    mutations: {
    },
    actions: {
        requestPasswordReset: async (context, username) => {
            return axios.post(ChickenLittle + `users/forgotPasswordRequest`, {
                username: username
            }).catch(err => errorHandler.tomcatError(err));
        },
        resetPassword: async (context, payload) => {
            return axios.post(ChickenLittle + `users/${payload.username}/resetPassword`, payload)
                .catch(err => errorHandler.tomcatError(err))
        },
    }
}
